export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/squarespace.7ff839c.svg";